export default __webpack_public_path__ + "static/media/bg-rental.cbe4acac.jpeg";